import { render, staticRenderFns } from "./TemplateCenter.vue?vue&type=template&id=2c17a22b&scoped=true"
import script from "./TemplateCenter.vue?vue&type=script&lang=js"
export * from "./TemplateCenter.vue?vue&type=script&lang=js"
import style0 from "./TemplateCenter.vue?vue&type=style&index=0&id=2c17a22b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c17a22b",
  null
  
)

export default component.exports